<script setup lang="ts">
import { memberService } from '@/services/api';
import { isDemoMode } from '@template/utils';
import { BaseButton } from '@template/ui';
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';

const showSubmit = ref(false);

onMounted(async () => {
  if (!isDemoMode()) return;
  try {
    const res = await memberService.getInfo();
    showSubmit.value = res.data?.kycStatus === 'NOT_SUBMITTED';
  } catch {
    showSubmit.value = false;
  }
});

const emit = defineEmits<{
  (e: 'click'): void;
}>();
</script>

<template>
  <BaseButton
    v-if="showSubmit"
    variant="contained"
    color="primary"
    size="sm"
    fullWidth
    label="고객확인 서류 제출하기"
    @click="emit('click')"
  />
</template>
